import styled from 'styled-components';

export const ChestWrap = styled.div`
  width: 100%;
`;
